export default {
  authentication: {
    authentication: 'Innskráning',
    register: 'Stofna aðgang / Nýr notandi',
    username: 'Netfang',
    password: 'Lykilorð',
    passwordConfirmation: 'Endurtaktu lykilorð',
    login: 'Innskrá',
    error: {
      usernameMissing: 'Sláðu inn netfang',
      passwordMissing: 'Sláðu inn lykilorð',
      passwordsDoNotMatch: 'Lykilorð eru ekki eins',
    },
    resetPassword: 'Gleymt lykilorð',
    code: 'Kóði',
    email: 'Netfang',
    continue: 'Áfram',
  },

  registration: {
    name: 'Fullt nafn',
    email: 'Netfang',
    password: 'Lykilorð',
    passwordConfirmation: 'Endurtekið lykilorð',
    create: 'Stofna aðgang',
    toAuthentication: 'Aftur í innskráningu',
    termsAndConditionsAgreement: 'Ég samþykki skilmála Lifetrack',
    error: {
      nameMissing: 'Sláðu inn fullt nafn',
      usernameMissing: 'Sláðu inn netfang',
      passwordMissing: 'Sláðu inn lykilorð',
      passwordsDoNotMatch: 'Lykilorð eru ekki eins',
      termsAndConditionsAgreementMissing: 'Þú þarf að samþykkja skilmála til að halda áfram',
    },
  },

  food: {
    query: 'Leita í nafni, flokki eða lýsingu',
    name: 'Titill',
    barcode: 'Strikamerki',
    brand: 'Vörumerki',
    category: 'Flokkur',
    description: 'Lýsing',
    carbs: 'Kolvetni (grömm)',
    protein: 'Prótein (grömm)',
    fat: 'Fita (grömm)',
    fiber: 'Trefjar (grömm)',
    sugar: 'Sykur (grömm)',
    serving: 'Skammtur (grömm)',
    measurement: 'Mælieining',
    verified: 'Staðfest af',
    createEntry: 'Stofna færslu',
    editEntry: 'Breyta færslu',
    deleteEntry: 'Eyða færslu',
    deleteEntryMessage: 'Ertu viss um að þú viljir eyða þessari færslu? {name}',
    report: {
      title: 'Tilkynna rangar upplýsingar um vöru',
      message: 'Vinsamlegast skráðu hér hvaða upplýsingar um vöruna eru rangar. Þessar upplýsingar verða svo áframsendar á LifeTrack teymið',
      foodInfo: 'Rangar upplýsingar um vöru',
    },
    error: {
      fieldRequired: 'Gildi er nauðsynlegt',
    },
    filter: {
      verified: 'Samþykkt',
      yes: 'Já',
      no: 'Nei',
    },
    notFound: {
      title: 'Vara fannst ekki',
      message: 'Þessi vara er ekki til ennþá. Til hamingju, þú færð þann heiður á að skrá hana! Okkur langar að biðja þig um að vanda þig og skrá eingöngu innihald í 100 gr. Takk fyrir að taka þátt í að byggja upp gagnagrunn LifeTrack',
    },
  },

  foodCategory: {
    beverage: 'Drykkur',
    canned: 'Dósamatur',
    fruit: 'Ávöxtur',
    meat: 'Kjöt',
    seafood: 'Sjávarfang',
    oil: 'Olía',
    vegetable: 'Grænmeti',
    other: 'Annað',
  },

  recipe: {
    create: 'Búa til uppskrift',
    my: 'Mínar uppskriftir',
    its: 'LifeTrack uppskriftir',
    title: 'Nafn á uppskrift',
    description: 'Skýringar með uppskrift',
    addIngredient: 'Bæta við hráefni',
    add: 'Bæta við',
    addRecipe: 'Vista uppskrift',
    delete: {
      title: 'Eyða uppskrift',
      message: 'Ertu viss um að þú viljir eyða þessari uppskrift?',
    },
    change: 'Breyta uppskrift',
    macrosValues: 'Í 100 gr. af uppskriftinni',
    amountAfterCooking: 'Þyngd eftir eldun',
    removeItem: {
      title: 'Fjarlægja hráefni',
      message: 'Ertu viss um að þú viljir fjarlægja þetta hráefni?',
    },
  },

  meal: {
    create: 'Búa til máltíð',
    my: 'Mínar máltíðir',
    its: 'LifeTrack máltíðir',
    title: 'Nafn á máltíð',
    description: 'Skýringar með máltíð',
    addIngredient: 'Bæta við hráefni',
    add: 'Bæta við',
    usePrivateFood: 'Skrá macros',
    addMacros: 'Skrá macros',
    delete: {
      title: 'Eyða máltíð',
      message: 'Ertu viss um að þú viljir eyða þessari máltíð?',
    },
    addMeal: 'Vista máltíð',
    change: 'Breyta máltíð',
    macrosValues: 'Í 100 gr. af máltíðinni',
    search: 'Leita að máltíð',
    removeItem: {
      title: 'Fjarlægja hráefni',
      message: 'Ertu viss um að þú viljir fjarlægja þetta hráefni?',
    },
    selectDateDialog: {
      title: 'Veldu dagsetningu og matmálstíma',
      message: 'Vinsamlegast veldu dagsetningu og matmálstíma til að klára skráningu',
    },
  },

  journal: {
    toolbarTitle: 'Dagbók',
    addEntry: 'Skrá færslu',
    editEntry: 'Breyta færslu',
    createMeal: 'Skrá sem máltíð',
    copyMealTime: 'Afrita skráningar',
    amount: 'Magn',
    search: 'Leita eftir vöru',
    recipes: 'Uppskriftir',
    recipe: 'Uppskrift',
    meals: 'Máltíðir',
    product: 'Vara',
    foodCreate: 'Búa til vöru',
    scan: 'Skanna vöru',
    quick: 'Notanda færsla',
    quickAdd: 'Hraðskrá',
    saveAsMeal: 'Vista sem máltíð',
    lastUsed: 'Síðast notað',
    recentlyUsed: 'Nýlega notað',
    recentlyUsedNoEntry: 'Þú hefur ekki notað vöru úr þessum flokki nýlega',
    register: 'Skrá',
    productTitle: 'Heiti vöru',
    productBrand: 'Framleiðandi / fyrirtæki',
    edit: 'Breyta færslu',
    productInUnits: 'Stofna vöru líka sem stk.',
    productGramsInUnit: 'Skráðu hve mörg grömm í einu stykki',
    measurement: 'Mælieining',
    takeaway: 'Út að borða',
    takeawayDisclaimer: 'Næringarupplýsingar eru byggðar á upplýsingum frá heimasíðum matsölustaða',
    brand: 'Veitingastaður',
    cheatDay: 'Frídagur',
    mostUsed: 'Mest notað',
    macros: {
      carbs: 'Kolvetni',
      fat: 'Fita',
      protein: 'Prótein',
      fiber: 'Trefjar',
      calories: 'Hitaeiningar',
      sugar: 'Sykur',
      caloriesGoal: 'Markmið',
      usedCalories: 'Notaðar',
      remainingCalories: 'Eftir',
      sugarDisclaimer: 'Landlæknir mælir með að sykurinntaka sé ekki meiri en 10% af heildar næringarinntöku yfir daginn',
    },
    mealtime: {
      title: 'Matmálstími',
      breakfast: 'Morgunmatur',
      snack1: 'Millimál 1',
      lunch: 'Hádegismatur',
      snack2: 'Millimál 2',
      dinner: 'Kvöldmatur',
      snack3: 'Millimál 3',
    },
    hTracker: {
      title: 'Verkefni dagsins',
      open: 'Ég',
      close: 'Loka',
      exercise: 'Hreyfingin mín',
      movementMinutes: 'Hreyfing í mínútum',
      health: 'Heilsa',
      sleep: 'Svefn í klukkustundum',
      water: 'Vatn í lítrum',
      mood: 'Skap',
      attitude: 'Hugarfar og hegðun',
      positivity: 'Jákvæðni',
      thankfulness: 'Þakklæti',
      initiative: 'Frumkvæði',
      somethingDifficult: 'Gerði ég eitthvað erfitt í dag',
      goodDeed: 'Lét ég gott af mér leiða eða gerði ég góðverk',
      showedLove: 'Sýndi ég fólkinu mínu ást',
      note: 'Dagbókin mín',
      experience: 'Skrifaðu niður t.d. þar sem þér fannst standa uppúr í dag. Hvað þú gerðir vel og hvað þú ætlar að gera betur á morgun.',
      yes: 'Já',
      no: 'Nei',
      save: 'Vista og loka',
    },
    delete: {
      title: 'Eyða færslu',
      message: 'Ertu viss um að þú viljir eyða þessari færslu?',
    },
    plus: {
      title: 'Plús',
      difficultWorkout: 'Erfið æfing',
      veryDifficultWorkout: 'Mjög erfið æfing',
      cheatDay: 'Nammidagur',
      period: 'Blæðingar',
    },
    target: 'Mín markmið',
    macroTarget: 'Markmið dagsins',
  },

  asset: {
    removeImage: {
      title: 'Fjarlægja mynd',
      message: 'Ertu viss um að þú viljir fjarlægja þessa mynd?',
    },
    selectFile: 'Velja mynd',
    changeFile: 'Velja nýja mynd',
  },

  calculator: {
    toolbarTitle: {
      step4: 'Orkuþörf',
      step5: 'Macros',
    },
    activityOptions: {
      none: 'Engin hreyfing',
      small: '1-2 sinnum í viku',
      medium: '3-4 sinnum í viku',
      large: '4-5 sinnum í viku',
      xLarge: '5 sinnum eða oftar/afreksþjálfun',
    },
    goalsOptions: {
      gain: 'Þyngjast / Styrkjast',
      maintain: 'Viðhalda / Styrkjast',
      lose: 'Léttast',
      loseFast: 'Léttast hratt',
    },
    calculateNumbers: 'Reikna tölur',
    myNumbers: 'Mínar tölur',
    none: 'Ekkert',
    small: 'Lítið',
    medium: 'Meðal',
    large: 'Mikið',
    xLarge: 'Mjög mikið',
    noneKvk: 'Engin',
    smallKvk: 'Lítil',
    mediumKvk: 'Meðal',
    largeKvk: 'Mikil',
    gender: 'Kyn',
    age: 'Aldur',
    height: 'Hæð',
    weight: 'Þyngd',
    exercise: 'Hreyfing',
    goals: 'Markmið',
    male: 'Karlkyn',
    female: 'Kvenkyn',
    other: 'Annað',
    step4TextTop1: 'Hér að neðan er áætluð orkuþörf yfir daginn.',
    step4TextTop2: 'Þó að þessi orkuþörf sé unnin með fagaðilum er mikilvægt að benda á að við erum öll misjöfn og það sem hentar einum þarf ekki endilega að henta öðrum.',
    step4TextTop3: 'Þetta er góðu útgangspunktur til þess að hefja þitt ferðalag og finna út hvar þín orkuþörf liggur miðað við þín markmið.',
    step4TextBottom1: 'Orkuþörf líkamans vísar til magns orku (hitaeininga) sem líkaminn þarf til að viðhalda eðlilegri líkamsstarfsemi, samsetningu og daglegri hreyfingu.',
    step4TextBottom2: 'Ef þú vilt breyta tölum enn frekar er hægt að gera það undir mínar tölur.',
  },

  form: {
    search: 'Leita',
    submit: 'Skrá',
    save: 'Vista',
    saveAndConfirm: 'Vista og Samþykkja',
    forward: 'Áfram',
    confirm: 'Staðfesta',
    cancel: 'Hætta við',
    back: 'Til baka',
    update: 'Uppfæra',
    add: 'Skrá',
    delete: 'Eyða',
  },

  evaluation: {
    title: 'Mælingar',
    date: 'Dagsetning',
    weight: 'Þyngd',
    create: 'Skrá mælingu',
    noValues: 'Þú hefur ekki skráð mælingu',
    delete: {
      title: 'Eyða mælingu',
      message: 'Ertu viss um að þú viljir eyða mælingunni?',
    },
    edit: {
      title: 'Breyta færslu',
    },
  },

  subscription: {
    toolbarTitle: 'Áskrift',
    title: 'Áskrift',
    manage: 'Segja upp áskrift',
    active: 'Virk',
  },

  page: {
    toolbarTitle: 'Efnisveita',
    title: 'Efnisveita',
  },

  welcomeMessage: {
    title: 'Velkomin/n í LifeTrack',
    message1: 'Nú ert þú með heilsuna í vasanum. Þú getur prófað appið og skoðað allt efnið frítt næstu 3 dagana.',
    message2: 'Til þess að fá útreiknaða orkuþörf þína getur þú ýtt á MÍN MARKMIÐ. Að því loknu getur þú byrjað ferðalagið. Þegar þú vilt gerast áskrifandi mælum við með að tryggja þér hagstæðasta verðið í gegnum heimasíðu LifeTrack.',
  },

  error: {
    dialog: {
      default: {
        title: 'Villa',
        message: 'Keyrsla skilaði villu: "{error}"',
      },
      networkError: {
        title: 'Sambandsrof',
        message: 'Ekki náðist samband við þjónustur. Athugaðu hvort tækið sé tengt við internetið.',
      },
    },
  },

  date: {
    days: ['Sunnudagur', 'Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur', 'Laugardagur'],
    daysShort: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
    firstDayOfWeek: 1,
  },

  navigation: {
    title: 'Valmynd',
    myNumbers: 'Mínar tölur',
    logout: 'Útskráning',
    journal: 'Dagbók',
    recipe: 'Uppskrift',
    meal: 'Máltíð',
    evaluation: 'Mælingar',
    settings: 'Stillingar',
    content: 'Efnisveita',
    privacy: 'Persónuverndarstefna',
    eula: 'Notkunarskilmálar',
    news: 'Fréttaveita LifeTrack',
  },
  settings: {
    title: 'Stillingar',
    version: 'Útgáfa',
    itsSync: {
      title: 'ITS Macros tenging',
      sync: 'Senda macros gildi yfir í ITS Macros',
      description: 'Fyrir notendur ITS Macros er hægt að tengja saman skráningu macros gilda. Það er gert með því að skrá inn notandann sem á að tengja við. Athugið að nota aðganginn að ITS Macros.',
      accountSynced: 'Búið er að tengja eftirfarandi notanda:',
      disconnect: 'Aftengja',
      dialog: {
        success: {
          title: 'Sending tókst',
          message: 'Macros gildi hafa verið send yfir í ITS Macros',
        },
        notice: {
          title: 'Senda macros gildi',
          message: 'Macros gildin sem eru skráð á þennan dag verða send yfir í ITS Macros og skráð á sama dag. Athugaðu að þær skráningar sem þegar eru til í ITS Macros fyrir þennan dag verða yfirskrifaðar.',
          ok: 'Senda skráningu',
          cancel: 'Hætta við',
        },
      },
    },
    showGoals: {
      title: 'Birting markmiða',
      macros: 'Birta Macros markmið',
      calories: 'Birta hitaeiningamarkmið',
      none: 'Fela markmið',
    },
  },
  news: {
    toolbarTitle: 'Fréttaveita LifeTrack',
    newest: 'Nýjar fréttir',
    pinned: 'Vinsælar færslur',
  },
};
